type NoArgFunction = () => void
export const customAwait = (funciones: NoArgFunction[], time: number = 1000) => {
  for (const fn of funciones) {
    setTimeout(fn, time)
  }
}
